import { BreakerApplication } from 'unitData/Breaker/BreakerTypes';
import type { UnitInfoJawCrusherInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import * as JawCrusherCJConfig from './CrusherJawCJTypes';

export const ModelTypes = [
  JawCrusherCJConfig.CrusherJawTypes.CJ211,
  JawCrusherCJConfig.CrusherJawTypes.CJ409,
  JawCrusherCJConfig.CrusherJawTypes.CJ411,
  JawCrusherCJConfig.CrusherJawTypes.CJ412,
  JawCrusherCJConfig.CrusherJawTypes.CJ613,
  JawCrusherCJConfig.CrusherJawTypes.CJ615,
  JawCrusherCJConfig.CrusherJawTypes.CJ815,
];

export class CrusherJawCJConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoJawCrusherInterface {
    return {
      modelName: ModelTypes[1],
      css: 125,
      ...BaseUnitConfig.getBaseDefaults(),
      showCustomModel: false,
      attachmentTool: {
        boom: undefined,
        breaker: undefined,
        powerPack: undefined,
        enabled: false,
        application: BreakerApplication.JAW_CRUSHER,
      },
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayCss: true,
        displayAttachmentTool: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const crusherJawCJConfig = new CrusherJawCJConfig();
